import React from "react";
import { Link } from "react-router-dom"; // 👈 Import Link for routing
import "./AboutCPIT.css";
import AboutImg from "../Component/Cpit8.jpg"; // 👈 Replace with your actual image path

const AboutCPIT = () => {
  // Mapping course names with their routes
  const courses = [
    { name: "NIELIT", path: "/nielit" },
    { name: "UPSDM", path: "/upsdm" },
    { name: "BSDM", path: "/bsdm" },
    { name: "ASDC", path: "/asdc" },
    { name: "PMKVY", path: "/pmkvy" },
    { name: "CSR", path: "/csr" },
    { name: "DDU-GKY", path: "/ddugky" },
    { name: "TTSC", path: "/ttsc" },
    { name: "NCVTE", path: "/ncvte" },
  ];

  return (
    <div className="about-cpit-section">
      {/* Hero Image Section */}
      <div className="about-banner">
        <img src={AboutImg} alt="About CPIT" className="about-image" />
      </div>

      {/* About Text Section */}
      <div className="container py-5">
        <h2 className="fw-bold mb-4 text-center text-primary">
          Career Point of Information Technology
        </h2>

        <p className="about-text">
          <strong>CPIT</strong> established in 2017, the name of Career Point of
          Information Technology “CPIT of Computer Education Trust” founded by
          Career Point Of Information Technology CPIT Education Trust nationwide
          as the leading provider of education programs for individuals and
          professionals as well.
          <br />
          <br />
          CPIT is into the field of quality education for last 8 years in
          different segments such as Information Technology, Skill Training,
          Computer Hardware & Networking, and the field of Accounts.
          <br />
          <br />
          As the largest and most comprehensive network, CPIT offers
          opportunities to choose a course that best meets a student’s unique
          academic and professional needs. Our mission is to empower learners
          through technical knowledge, skill development, and digital literacy
          for a better tomorrow.
        </p>

        {/* Partner / Course Section */}
        <div className="courses-section mt-5">
          <h3 className="fw-bold text-center mb-4 text-secondary">
            Our Associated Programs & Courses
          </h3>
          <div className="row justify-content-center text-center">
            {courses.map((course, index) => (
              <div key={index} className="col-6 col-md-3 mb-4">
                <Link
                  to={course.path}
                  className="text-decoration-none text-dark"
                >
                  <div className="course-box shadow-sm p-3 rounded hover-effect">
                    {course.name}
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutCPIT;
